// components/PrivateRoute.jsx
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const PrivateRoute = ({ children, allowedRoles = ["User", "Admin"] }) => {
  const { isAuthenticated, userRole, lastAllowedPath, setLastAllowedPath } =
    useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Not logged in → go to login
    if (!isAuthenticated) {
      navigate("/", { replace: true, state: { from: location } });
      return;
    }

    // Logged in but no role or not allowed → snap back to last allowed path
    if (!userRole || !allowedRoles.includes(userRole)) {
      navigate(lastAllowedPath || "/", { replace: true });
      return;
    }

    // Allowed: remember this path as the last allowed one
    setLastAllowedPath(location.pathname);
  }, [
    isAuthenticated,
    userRole,
    allowedRoles,
    navigate,
    location,
    lastAllowedPath,
    setLastAllowedPath,
  ]);

  // Render nothing while the effect decides; avoids visible route change
  if (!isAuthenticated || !userRole || !allowedRoles.includes(userRole)) {
    return null;
  }

  return children;
};

export default PrivateRoute;
